<template>
  <div class="results-widget">
    <v-subheader>{{ lang.orders.results.title }}</v-subheader>
    <v-row
      v-for="(result, i) in results"
      :key="i"
      class="result"
    >
      <v-col cols="9" v-text="result.title" class="result-label"/>
      <v-col cols="3" v-text="result.value" class="result-text"/>
    </v-row>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  computed: {
    results () {
      let data = (this.get_data || {}).financial || {}
      return [
        {
          title: this.lang.financial.cashflow.overview.all,
          value: (Object.values(data).reduce((add, val) => add.concat(val), []) || []).length
        }
      ]
    }
  }
}
</script>
